import { createContext } from "react";
const TabPanelsContext = createContext(
  null
);
export {
  TabPanelsContext
};
